import { Link } from "react-router-dom";
import { useI18n } from "../../../i18n/I18nContext";
import Footer from "../Footer/Footer";

export default function Partnerships() {
  const { t } = useI18n();

  const beneficios = [
  {
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M21 7.5l-9-5.25L3 7.5m18 0l-9 5.25m9-5.25v9l-9 5.25M3 7.5l9 5.25M3 7.5v9l9 5.25m0-9v9" />
      </svg>
    ),
    title: t("Gestão Otimizada de Armazém"),
    text: t("Integração perfeita entre sistemas de armazenamento físico e software de controlo de inventário para máxima eficiência operacional."),
  },
  {
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 18L9 11.25l4.306 4.307a11.95 11.95 0 015.814-5.519l2.74-1.22m0 0l-5.94-2.28m5.94 2.28l-2.28 5.941" />
      </svg>
    ),
    title: t("Aumento de Produtividade"),
    text: t("Automatize processos de entrada/saída de stock e reduza significativamente o tempo de localização de produtos."),
  },
  {
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z" />
      </svg>
    ),
    title: t("Velocidade de Entrega"),
    text: t("Com um WMS robusto, as suas operações logísticas tornam-se mais rápidas e precisas, reduzindo prazos de entrega."),
  },
  {
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z" />
      </svg>
    ),
    title: t("Controlo e Rastreabilidade"),
    text: t("Rastreie cada item em tempo real com precisão, garantindo conformidade e reduzindo erros de armazenamento."),
  },
  {
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />
      </svg>
    ),
    title: t("Suporte Especializado"),
    text: t("A Logistics WMS oferece suporte 24/7 e consultoria especializada para maximizar o ROI das soluções."),
  },
  {
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v12m-3-2.818l.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
    title: t("Redução de Custos"),
    text: t("Otimize espaço de armazém, reduza desperdício e melhore a lucratividade operacional com inteligência de dados."),
  },
];

const razoes = [
  t("Sistemas de estantes RacksForAll + WMS Logistics = Solução completa de armazenamento"),
  t("Infraestrutura física robusta que suporta operações de WMS de alta performance"),
  t("Dados precisos sobre capacidade e ocupação de estantes em tempo real"),
  t("Redução de 40% no tempo de picking graças à organização inteligente"),
t("Escalabilidade - cresce conforme a sua operação se expande"),
  t("ROI comprovado em menos de 12 meses"),
];

  return (
    <div className="min-h-screen bg-white flex flex-col">

      {/* Hero */}
      <section className="bg-indigo-700 pt-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-16 lg:py-20 text-center">
          <span className="inline-block text-xs font-semibold uppercase tracking-widest text-indigo-200 mb-4 bg-white/10 px-3 py-1 rounded-full">
            {t("Parceria Estratégica")}
          </span>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4 leading-tight">
            {t("Parceria:")} <span className="text-indigo-200">Logistics WMS</span>
          </h1>
          <p className="text-indigo-100/80 max-w-xl mx-auto text-base">
            {t("A solução completa para otimizar a gestão do seu armazém com as estantes profissionais RacksForAll.")}
          </p>
        </div>
        <div className="overflow-hidden leading-none">
          <svg viewBox="0 0 1440 60" className="w-full" preserveAspectRatio="none" style={{ height: 60 }}>
            <path d="M0,40 C360,80 1080,0 1440,40 L1440,60 L0,60 Z" fill="white" />
          </svg>
        </div>
      </section>

      {/* Sobre Logistics WMS */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
          <div className="rounded-3xl border border-gray-200 bg-white shadow-md overflow-hidden">
            <div className="bg-indigo-600 px-8 py-6">
              <span className="inline-block text-xs font-semibold uppercase tracking-widest text-indigo-200 mb-2">
                {t("O nosso parceiro")}
              </span>
              <h2 className="text-xl sm:text-2xl font-bold text-white">{t("Sobre Logistics WMS")}</h2>
            </div>
            <div className="grid lg:grid-cols-2 gap-0 items-center">
              <div className="px-8 py-8 space-y-5">
                <p className="text-sm text-gray-500 leading-relaxed">
                  {t("Logistics WMS é uma plataforma líder de Warehouse Management System, desenvolvida para empresas que buscam excelência operacional. Fornece controlo total sobre inventário, otimização de espaço e integração seamless com sistemas logísticos.")}
                </p>
                <a
                  href="https://www.logisticswms.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1.5 text-sm font-semibold text-indigo-600 hover:text-indigo-800 transition-colors group"
                >
                  {t("Visitar site oficial")}
                  <svg className="w-4 h-4 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                  </svg>
                </a>
              </div>
              <div className="flex items-center justify-center px-8 py-8 bg-gray-50 border-t lg:border-t-0 lg:border-l border-gray-100 min-h-48">
                <img
                  src="/wms-preview.png"
                  alt="Logistics WMS Preview"
                  className="w-full max-w-sm rounded-xl shadow-md"
                  onError={(e) => {
                    e.target.parentElement.innerHTML = `<div class="text-gray-300 text-sm text-center">${t("Imagem em breve")}</div>`;
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefícios */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
          <div className="text-center mb-12">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3">{t("Benefícios das Soluções Integradas")}</h2>
            <p className="text-gray-500 text-sm sm:text-base max-w-2xl mx-auto">
              {t("Quando RacksForAll encontra Logistics WMS, o resultado é uma operação de armazém de classe mundial")}
            </p>
          </div>
          <div className="grid sm:grid-cols-2 gap-4 max-w-5xl mx-auto">
            {beneficios.map((b) => (
              <div key={b.title} className="rounded-3xl border border-gray-200 bg-white shadow-md overflow-hidden hover:shadow-lg hover:-translate-y-0.5 transition-all">
                <div className="bg-indigo-600 px-6 py-4 flex items-center gap-3">
                  <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-white/20 text-white">
                    {b.icon}
                  </div>
                  <h3 className="font-bold text-white text-sm">{b.title}</h3>
                </div>
                <div className="px-6 py-4">
                  <p className="text-sm text-gray-500 leading-relaxed">{b.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Por Que RacksForAll + WMS */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
          <div className="text-center mb-12">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3">{t("Porque RacksForAll + Logistics WMS?")}</h2>
            <p className="text-gray-500 text-sm sm:text-base">
              {t("A combinação perfeita de infraestrutura física e software inteligente")}
            </p>
          </div>
          <div className="grid sm:grid-cols-2 gap-4 max-w-4xl mx-auto">
            {razoes.map((r) => (
              <div key={r} className="flex items-center gap-3 rounded-2xl border border-gray-200 bg-white px-5 py-4 shadow-md">
                <div className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full border-2 border-indigo-500 text-indigo-600">
                  <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <span className="text-sm text-gray-700 font-medium">{r}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-10 text-center">
          <div className="rounded-3xl border border-gray-200 bg-white shadow-md px-8 py-12">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3">{t("Pronto para Otimizar o Seu Armazém?")}</h2>
            <p className="text-gray-500 mb-8 text-sm sm:text-base max-w-lg mx-auto">
              {t("Combine as soluções de estantes profissionais RacksForAll com o poderoso WMS da Logistics para transformar a sua operação logística.")}
            </p>
            <div className="flex flex-wrap gap-3 justify-center">
              <Link
                to="/contact"
                className="px-8 py-3 rounded-xl bg-indigo-600 text-white font-semibold text-sm hover:bg-indigo-700 shadow-sm transition"
              >
                {t("Contacte-nos")}
              </Link>
              <a
                href="https://www.logisticswms.com"
                target="_blank"
                rel="noopener noreferrer"
                className="px-8 py-3 rounded-xl border border-gray-200 text-sm font-semibold text-gray-700 hover:bg-gray-100 transition"
              >
                {t("Saber Mais")}
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}